export default {
  SET_BANNERS(state, value) {
    state.banners = value.filter(
      (obj) => obj.place !== 'tasks' && obj.place !== 'private_offers',
    );
  },
  SET_PRIVATE_OFFERS_BANNERS(state, list) {
    state.privateOffersBanners = list.filter((obj) => obj.place !== 'tasks');
  },
  CLEAR_ACTIVE_BANNER(state) {
    state.activeBanner = {};
    state.activeBannerId = null;
    state.activePlace = null;
  },
  SET_SORTED_BANNERS_DIRECT(state, list) {
    state.sortedBanners = Array.isArray(list) ? list : [];
  },
  ADD_BANNER(state, place) {
    const draft = {
      place,
      name: '',
      type: 'custom',
      isEnabled: false,
      content: '',
      scrollDelay: 0,
      informations: [],
    };

    state.banners.push(draft);
  },

  ADD_PRIVATE_OFFERS_BANNER(state, place) {
    const draft = {
      place,
      name: '',
      type: 'custom',
      isEnabled: false,
      content: '',
      scrollDelay: 0,
      informations: [],
    };

    state.privateOffersBanners.push(draft);
  },
  CHECK_TRANSLATIONS(state) {
    const emptyTranslation = {
      buttonBgColor: '',
      buttonLink: '',
      buttonText: '',
      buttonTextColor: '',
      subTitle: '',
      subTitleColor: '',
      title: '',
      titleColor: '',
    };

    state.activeBanner.informations.forEach((info) => {
      if (!info.translations) {
        Object.assign(info, { translations: {} });
      }

      state.lang.forEach((lang) => {
        if (!info.translations[lang]) {
          Object.assign(info.translations, { [lang]: { ...emptyTranslation } });
        }
      });
    });
  },
  UPDATE_BANNER(state) {
    const emptyTranslation = {
      buttonBgColor: '',
      buttonLink: '',
      buttonText: '',
      buttonTextColor: '',
      subTitle: '',
      subTitleColor: '',
      title: '',
      titleColor: '',
    };
    const translations = {};

    state.lang.forEach((lang) => {
      translations[lang] = { ...emptyTranslation };
    });

    const newInfo = {
      backgroundImage: null,
      backgroundColor: '',
      image: null,
      sorting: state.activeBanner.informations.length,
      translations,
    };

    state.activeBanner.informations.push(newInfo);
  },
  SET_BANNER(state, banner) {
    const index = state.banners.findIndex((item) => item.id === banner.id);

    if (index !== -1) {
      Object.assign(state.banners[index], banner);
    } else {
      state.banners.push(banner);
    }
  },

  SET_PRIVATE_OFFERS_BANNER(state, banner) {
    const index = state.privateOffersBanners.findIndex((item) => item.id === banner.id);

    if (index !== -1) {
      Object.assign(state.privateOffersBanners[index], banner);
    } else {
      state.privateOffersBanners.push(banner);
    }
  },
  SET_LOADING(state, boolean) {
    state.loading = boolean;
  },
  DELETE_BANNER_SETTINGS(state, index) {
    state.activeBanner.informations.splice(index, 1);
  },
  SET_BANNER_NAME(state, name) {
    state.activeBanner.name = name;
  },
  SET_CONTENT(state, content) {
    state.activeBanner.content = content;
  },
  SET_TYPE(state, type) {
    state.activeBanner.type = type;
  },
  SET_ACTIVE_BANNER(state, index) {
    state.activeBanner = state.sortedBanners[index];
  },
  SET_ACTIVE_BANNER_ID(state, index) {
    state.activeBannerId = state.sortedBanners[index]?.id;
  },
  SET_ACTIVE_PLACE(state, index) {
    state.activePlace = state.sortedBanners[index]?.place;
  },
  SET_SCROLL_DELAY(state, value) {
    let scrollDelay = parseInt(value, 10);

    if (scrollDelay < 1) {
      scrollDelay = 1;
    } else if (scrollDelay > 15) {
      scrollDelay = 15;
    }

    state.activeBanner.scrollDelay = scrollDelay;
  },
  SET_BACKGROUND_IMAGE(state, {
    index,
    image,
  }) {
    state.activeBanner.informations[index].backgroundImage = image;
  },
  SET_IMAGE(state, {
    index,
    image,
  }) {
    state.activeBanner.informations[index].image = image;
  },
  SET_BACKGROUND_COLOR(state, {
    index,
    color,
  }) {
    state.activeBanner.informations[index].backgroundColor = color;
  },
  SET_TEXT_TITLE_COLOR(state, {
    index,
    lang,
    color,
  }) {
    if (!state.activeBanner.informations[index].translations[lang]) {
      Object.assign(state.activeBanner.informations[index].translations, { lang: {} });
    }

    Object.assign(state.activeBanner.informations[index].translations[lang], { titleColor: color });
  },
  SET_TITLE(state, {
    index,
    lang,
    text,
  }) {
    state.activeBanner.informations[index].translations[lang].title = text;
  },
  SET_SUBTITLE_TEXT_COLOR(state, {
    index,
    lang,
    color,
  }) {
    state.activeBanner.informations[index].translations[lang].subTitleColor = color;
  },
  SET_SUBTITLE(state, {
    index,
    lang,
    text,
  }) {
    state.activeBanner.informations[index].translations[lang].subTitle = text;
  },
  SET_BUTTON_TEXT_COLOR(state, {
    index,
    lang,
    color,
  }) {
    state.activeBanner.informations[index].translations[lang].buttonTextColor = color;
  },
  SET_BUTTON_TEXT(state, {
    index,
    lang,
    text,
  }) {
    state.activeBanner.informations[index].translations[lang].buttonText = text;
  },
  SET_BUTTON_BG_COLOR(state, {
    index,
    lang,
    color,
  }) {
    state.activeBanner.informations[index].translations[lang].buttonBgColor = color;
  },
  SET_BUTTON_LINK(state, {
    index,
    lang,
    text,
  }) {
    state.activeBanner.informations[index].translations[lang].buttonLink = text;
  },
  MOVE_UP(state, index) {
    if (index > 0) {
      const [item] = state.activeBanner.informations.splice(index, 1);

      state.activeBanner.informations.splice(index - 1, 0, item);
      state.activeBanner.informations[index].sorting = index;
      state.activeBanner.informations[index - 1].sorting = index - 1;
    }
  },
  MOVE_DOWN(state, index) {
    if (index < state.activeBanner.informations.length - 1) {
      const [item] = state.activeBanner.informations.splice(index, 1);

      state.activeBanner.informations.splice(index + 1, 0, item);
      state.activeBanner.informations[index].sorting = index;
      state.activeBanner.informations[index + 1].sorting = index + 1;
    }
  },
  SET_SORTED_BANNERS(state, value) {
    if (value === 'disabled') {
      state.sortedBanners = state.banners.filter((item) => item.type === 'none');
    } else if (value === 'active') {
      state.sortedBanners = state.banners.filter((item) => item.type !== 'none');
    } else {
      state.sortedBanners = state.banners;
    }
  },
  SET_STATUS(state, val) {
    state.status = val;
  },
  RESET_BANNER_INFORMATIONS(state) {
    if (state.activeBanner.informations.length) {
      state.activeBanner.informations = state.activeBanner.informations.filter((info) => info.id);
    }
  },
  SET_COPIED_BANNER_INFORMATION(state, information) {
    state.copiedBannerInformation = information
      ? JSON.parse(JSON.stringify(information))
      : null;
  },
  REPLACE_ACTIVE_BANNER_INFORMATION(state, {
    index,
    information,
  }) {
    if (!state.activeBanner || !Array.isArray(state.activeBanner.informations)) {
      return;
    }

    if (!state.activeBanner.informations[index]) {
      state.activeBanner.informations.splice(index, 0, information);
    } else {
      state.activeBanner.informations.splice(index, 1, information);
    }
  },
};
